import { baseApi } from "../app-main/store/baseApi";
import { HostDisintermediationRiskLevel } from "@ps-design-system/components/HostDisintermediation";

export type HostResponsivenessResponse = {
  metric: "HOST_RESPONSIVENESS";
  host_id: string;
  minutes: number;
  hours: number;
  bucket: string;
  level: number;
  level_label: string;
};

export type HostPlatformRiskResponse = {
  level: HostDisintermediationRiskLevel;
  set_at: string | null;
  dismissed_recently: boolean;
};

export type HostPlatformRiskDismissResponse = {
  message: string;
};

export type HostPlatformRiskAcknowledgeResponse = {
  message: string;
};

export const profilesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getHostResponsiveness: builder.query<HostResponsivenessResponse, void>({
      query: () => ({
        url: "/v2/profiles/host-responsiveness",
      }),
    }),
    getHostPlatformRisk: builder.query<HostPlatformRiskResponse, void>({
      query: () => ({
        url: "/v2/profiles/host/platform-risk",
      }),
    }),
    dismissHostPlatformRisk: builder.mutation<
      HostPlatformRiskDismissResponse,
      void
    >({
      query: () => ({
        url: "/v2/profiles/host/platform-risk/dismiss",
        method: "POST",
      }),
    }),
    acknowledgeHostPlatformRisk: builder.mutation<
      HostPlatformRiskAcknowledgeResponse,
      void
    >({
      query: () => ({
        url: "/v2/profiles/host/platform-risk/acknowledge",
        method: "POST",
      }),
    }),
  }),
  overrideExisting: false,
});
export const {
  useGetHostResponsivenessQuery,
  useAcknowledgeHostPlatformRiskMutation,
  useDismissHostPlatformRiskMutation,
  useGetHostPlatformRiskQuery,
} = profilesApi;
